import { render, staticRenderFns } from "./TelemetryBanner.vue?vue&type=template&id=b9ad878a&"
import script from "./TelemetryBanner.vue?vue&type=script&lang=js&"
export * from "./TelemetryBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports